import React, {useState} from 'react';
import {Calendar} from "primereact/calendar";
import {dateToDMY} from "../../utils/dateUtils";
import {Button} from "primereact/button";
import {downloadExport} from "../../utils/exportUtils";

function ThermalReport(props) {
    const [ dateFrom, setDateFrom ] = useState(new Date());
    const [ dateTo, setDateTo ] = useState(new Date());
    const dateFromString = dateToDMY(dateFrom);
    const dateToString = dateToDMY(dateTo);


    const generateFileName = (type) => {
        return `export_thermal_${type}_from_${dateFromString}_to_${dateToString}.xls`;
    }

    const generateExportUrl = (type) => {
        return `thermal/report/${type}ScanExport?fromDate=${dateFromString}&toDate=${dateToString}`
    }

    return (
        <div>
            <div className="my-4">
                <p>
                    Select a date range and report type
                </p>
            </div>
            <div className="w-full flex mb-4">
                <div>
                    <label htmlFor="date-from-input"> Date from </label>
                    <div>
                        <Calendar inputId="date-from-input"
                                  dateFormat="dd/mm/yy"
                                  value={dateFrom}
                                  onChange={(e) => setDateFrom(e.value)}
                                  maxDate={dateTo}
                        />
                    </div>
                </div>


                <div className="ml-8">
                    <label htmlFor="date-to-input"> Date to </label>
                    <div>
                        <Calendar inputId="date-to-input"
                                  dateFormat="dd/mm/yy"
                                  value={dateTo}
                                  onChange={(e) => setDateTo(e.value)}
                                  maxDate={new Date()}
                                  minDate={dateFrom}
                        />
                    </div>
                </div>
            </div>
            <div className="mt-8 flex">
                <div>
                    <Button
                        label="Download missing tests"
                        onClick={() => downloadExport(generateExportUrl("missed"), generateFileName("missed"))}
                    />
                </div>
                <div className="ml-8">
                    <Button
                        label="Download failed tests"
                        onClick={() => downloadExport(generateExportUrl("failed"), generateFileName("failed"))}
                    />
                </div>
                <div className="ml-8">
                    <Button
                        label="Download passed tests"
                        onClick={() => downloadExport(generateExportUrl("passed"), generateFileName("passed"))}
                    />
                </div>
            </div>
        </div>
    );
}

export default ThermalReport;